export default "__VITE_ASSET__DUkr4n0z__"